const english = {
    STATISTICS: 'Statistics',
    SYSTEM: 'System',
    NEXT: 'next',
    USERNAME: 'Username',
    PASSWORD: 'Password',
    LOG_IN: 'Sign in',
    LOG_OUT: 'Sign out',
    LOGIN_FAILED: 'Sign in failed',
    RESET_PASSWORD_SUCCEEDED: 'Email sent!',
    RESET_PASSWORD_FAILED: 'Could not send email',
    FORGOT_PASSWORD: 'Forgot password?',
    NETWORK_ERROR_MESSAGE: 'Could not connect to server',
    SETTINGS: 'Settings',
    CUSTUMER_REPORT: 'Customer report',
    COMPANY_REPORT: 'Company report',
    ANALYSIS: 'Analysis',
    LEADS: 'Leads',
    LEADS_PER: 'Leads per',
    LEADS_PER_TYPE: 'Leads per type',
    SEARCH_WORDS: 'Search words',
    SEARCHES: 'Searches',
    SEARCHES_PER: 'Searches per',
    SEARCHES_PER_SEARCH_WORD: 'Searches per search word',
    SEARCH: 'Search',
    CANCEL: 'Cancel',
    REPORTS: 'Reports',
    SHOW: 'Show',
    CLEAR: 'Clear',
    TOTALLY: 'Totally',
    PERIOD: 'Period',
    VKIID: 'VkiId',
    TYPE_OF_LEAD: 'Type of Lead',
    PAGE: 'Page',
    PAGES: 'Pages',
    LEAD_ORIGIN: 'Lead origin',
    LEAD_SOURCE: 'Lead source',
    SOURCE: 'Source',
    SOURCES: 'Sources',
    WHAT: 'What',
    WHERE: 'Where',
    COUNT: 'Count',
    TOTAL: 'Total',
    OF: 'Of',
    PER_PAGE: 'Per page',
    PLACE: 'Place',
    FROM: 'From',
    TO: 'To',
    ALL_PLACES: 'All places',
    GROUP_BY: 'Group',
    DAY: 'Day',
    WEEK: 'Week',
    MONTH: 'Month',
    ALSO_INCLUDES: 'Also includes',
    LANGUAGE: 'Language',
    SWEDISH: 'Swedish',
    ENGLISH: 'English',
    CLOSE: 'Close',
    YESTERDAY: 'Yesterday',
    LAST_WEEK: 'Last week',
    LAST_MONTH: 'Last month',
    PAST_YEAR: 'Past year',
    PAST_TWO_YEARS: 'Past two years',
    PRODUCT: 'Product',
    PRODUCTS: 'Products',
    ALL: 'All',
    ONLY_CUSTOMERS: 'Only customers',
    SHARE: 'Share',
    CUSTOMER: 'Customer',
    NONCUSTOMER: 'None customer',
    COMPANY: 'Company',
    COMPANIES: 'Companies',
    CITY: 'City',
    HID: 'HID, (Vkiid)',
    ORG_NUMBER: 'Corporate number',
    IMPRESSION: 'Impression',
    IMPRESSIONS: 'Impressions',
    IMPRESSIONS_PER: 'Impressions per',
    IMPRESSIONS_PER_TYPE: 'Impressions per type',
    CTR: 'CTR',
    KPI: 'Key values',
    SUMMARY: 'Summary',
    CLICK: 'Click',
    SELECTED: 'selected',
    CLICK_IN_LIST: 'Click in list',
    CTR_IN_LIST: 'CTR in list',
    IMPRESSION_IN_LIST: 'Impression in list',
    IMPRESSION_IN_SUGGEST: 'Impression in search suggest',
    IMPRESSION_OF_DETAILPAGE: 'Detail page impression',
    SELECT_COMPANIES: 'Select companies',
    TOOLTIP_SEARCH_COMPANIES: 'New search with selected companies',
    TOOLTIP_HID_INPUT_DISABLED: 'HID is set automatically when company is selected above',
    TOOLTIP_HID_INPUT: 'Separated with , (comma) to search multiple HID',
    TOOLTIP_ORGNO_INPUT_DISABLED: 'Corporate registration number can not be combined with HID',
    TOOLTIP_ORGNO_INPUT: 'Enter entier corporate number',

    TOOLTIP_DETAIL_EXPOSURE: 'Detailpage was shown',
    TOOLTIP_LIST_EXPOSURE: 'Company appeared in resultlist',
    TOOLTIP_SUGGEST_EXPOSURE: 'Campany appeared in search sugestions',
    TOOLTIP_MAP_EXPOSURE: 'Company appeared in the map search',

    TOOLTIP_PRODUCT_LEAD: {
        'offer-button-company': 'Offer button',
        grabover: 'Grabover',
        brf_report: 'Brf-rapport',
        facebook: 'Click on facebook-link',
        favorit: 'Added as favourite',
        foretagsgruppering: 'Företagsgruppering',
        'grafisk-annons': 'Click on Displayplacement',
        hemsidelank: 'Click on hompage-link',
        infosida: 'Infosida',
        'infosida-delux': 'Infosida deluxe',
        kopieraadress: 'Address was copied',
        kopieratelefonnr: 'Phonenumber was copied',
        print: 'Detailpage was printed',
        route: 'Click on directions-link',
        share_sms: 'Detailpage was shared via SMS',
        show_on_map: 'Click on Show on map',
        streetview: 'Click on Streetview',
        telefonnr: 'Click on Visa nummer or Call in appen',
        'topp4-logo': 'Topplacering',
        'topp4-annons': 'Topp 4 annons',
        visatelefonnr: 'Click on Visa nummer',
        detail: 'Detalj?',
        email: 'Click on Send email',
        'email-sent': 'Email was sent',
        livstilskartan: 'Livsstilskartan',
        save: 'Saved as contact',
        textlank: 'Click on Textlänk',
        'logo-listning': 'Logolistning',
        share: 'Dela',
        share_email: 'Detailpage was shared via epost',
        deluxebild: 'Deluxebild',
        share_facebook: 'Detailpage was shared via Facebook',
        'topp4-bilder': 'Click on Topplacering bild',
        'suggest-ad': 'Click on Söktips',
        sms: 'Click on sms button',
        'kopieraorg.nummer': 'Organisationsnummret was copied',
        kopieraemail: 'Email address was copied',
        grunduppgift: 'Grunduppgift',
        direktbokning: 'Click on booking button',
        vardlank: 'Click on Direktlänk Vård',
        butiklank: 'Click on Direktlänk Butik',
        menylank: 'Click on Direktlänk Meny',
        bestallank: 'Click on Direktlänk Beställ',
        deluxeheader: 'Click on Deluxeheader',
        'infosida-logo': 'Click on Infosida logo',
        logo: 'Click on Logo',
        suggest: 'Click on Sökförslag',
        soktraff: 'Click on Sökträff',
        kartuppgift: 'Click on Kartuppgift',
        '-': '-',
        'result-customers-nearby': '(result-customers-nearby)',
        _clicklist: '(_clicklist)',
        '': '()',
        total: 'Total',
        other: 'Other',
    },

    STATISTICS_FOR: 'Statistics for',
    SEARCH_STATISTICS: 'Search statistics',
    SEARCH_COMPANIES: 'Search company',
    NO_RESULT_TO_SHOW: 'No result to show',
    NO_RESULT_MESSAGE: 'no result to show',
    PRINT: 'Print',
    COMPANY_NAME: 'Company name',
    SEARCH_BY: 'Search by',
    ORDER_NUMBER: 'Order number',
    ACTIVE_ORDER: 'Active order',
    EDIT: 'Edit',
    TYPE: 'Type',
    CONTACT: 'Contact',
    CUSTOMER_CONTACTS: 'Customer contacts',
    CUSTOMER_CONTACTS_PER: 'Customer contacts per',
    CUSTOMER_CONTACTS_SHOWN_IN_TABLE: 'Customer contacts shown in table',
    COMPANIES_INCLUDED_IN_REPORT: 'companies included in report',
    HELPTEXT_SELECT_COMPANIES_FOR_REPORT: 'Select the companies that should be included in the report',
    CONTACT_AND_EXPO_STATS: 'Contact & impression statistics',
    REPORT_HEADER: 'Report header',
    REPORT_SETTINGS: 'Report settings',
    SHOW_GRAPHS: 'Show graphs',
    SHOW_PER_COMPANY: 'Show per company',
    SHOW_AMOUNTS: 'Show amounts',
    HEADER: 'Header',
    LAST_7_DAYS: 'Last seven days',
    WEEK_BEFORE: 'Week before',
    LINK: 'Link',
    NATIONWIDE: '(Nationwide)',
    HELP: 'Help',
    CLEAR_SEARCH_HISTORY: 'Clear search history',
    HISTORY_CLEARED: 'Search history cleared!',
    USE_ORDER_PERIOD: 'Use order period',
    OPEN_IN_ORDER_SYSTEM: 'Open in ordersystem',
    AND: 'And',
    MORE: 'More',

    HELP_SECTION: {
        HEADER: 'Welcome to the new statistics system',
        INGRESS: 'Welcome to the new statistical system that will replace Census. Initially, there are two reports available, search words and company report',

        SUBHEADER_1: 'Search words',
        PARAGRAPH_1: 'Used for search statistics. Fill in "What" and "Where" and get a summary of searches made last year at hitta.se and in the apps for iOS and Android.',

        SUBHEADER_2: 'Company report',
        PARAGRAPH_2_1: 'Used for contact and exposure statistics. Choose how to search for companies in the "Search by" menu and then type in the named field to the right. Statistics are displayed for the last year, if you choose to search with a order number the orders start and end date will be used',
        PARAGRAPH_2_2: 'After you press "Search" and the report is displayed, you can also fine-tune the report in the "Report settings" box, where you can choose which data to include, write your own heading, and fine-tune which companies are included.',

        SUBHEADER_3: 'Print / PDF',
        PARAGRAPH_3: 'Both reports are adapted for printing and "Save as PDF" via the browsers printing function. Hide default page header and page footer via the browser print settings.',

        SUBHEADER_4: 'Something is missing',
        PARAGRAPH_4: 'Do you feel that any functionality is missing? The statistics system is designed to provide as simple as possible answers to the questions about statistics that may arise during sales. Somthing missing? Send feedback to statistiksystemet@hitta.se',

        SUBHEADER_5: 'Feedback',
        PARAGRAPH_5: 'Send feedback to statistiksystemet@hitta.se',
    },

    COMPANY_SEARCH_LABEL: {
        HID: 'HID, (Vkiid)',
        ORG_NUMBER: 'Corporate number',
        COMPANY_NAME: 'Company name',
        ORDER_NUMBER: 'Order number',
    },

    COMPANY_SEARCH_PLACEHOLDER: {
        HID: 'jacccqbhi or hitta.se-link (separated by ,)',
        ORG_NUMBER: 'Corporate number',
        COMPANY_NAME: 'Company name',
        ORDER_NUMBER: 'Order number',
    },

    COMPANY_REPORT_PAGE_TITLE: 'Company report | Statisticsystem',
    SEARCH_STATS_PAGE_TITLE: 'Search words | Statisticsystem',
    COMPANY_ANALYSIS_PAGE_TITLE: 'Company analysis | Statisticsystem',
    LEADS_ANALYSIS_PAGE_TITLE: 'Leads analysis | Statisticsystem',
    IMPRESSION_ANALYSIS_PAGE_TITLE: 'Impression analysis | Statisticsystem',
    LOGIN_PAGE_TITLE: 'Login | Statisticsystem',

    ERROR_MESSAGE_SERVER_ERROR: 'An error occurred on the server',
    ERROR_MESSAGE_UNAUTHORIZED: 'You have been signed out',
    ERROR_MESSAGE_GENERIC: 'An error occurred',
    ERROR_MESSAGE_DATE_RANGE: 'Max period allowed is 2 years',

    PRODUCT_KEYS: {
        'offer-button-company': 'Offer button company',
        grabover: 'Grabover',
        brf_report: 'Brf-rapport',
        facebook: 'Facebook',
        favorit: 'Favourite',
        foretagsgruppering: 'Företagsgruppering',
        'grafisk-annons': 'Displayplacering',
        hemsidelank: 'Hompage click',
        infosida: 'Infosida',
        'infosida-delux': 'Infosida deluxe',
        kopieraadress: 'Copy address',
        kopieratelefonnr: 'Copy phone number',
        print: 'Print',
        route: 'Directions',
        share_sms: 'Share by SMS',
        show_on_map: 'Show on map',
        streetview: 'Streetview',
        telefonnr: 'Call',
        'topp4-logo': 'Topplacering',
        'topp4-annons': 'Topp 4 annons',
        visatelefonnr: 'Reveal number',
        detail: 'Detail?',
        email: 'Email',
        'email-sent': 'Email sent',
        livstilskartan: 'Lifestyle map',
        save: 'Save',
        textlank: 'Textlänk',
        'logo-listning': 'Logolistning',
        share: 'Share',
        share_email: 'Share by email',
        deluxebild: 'Deluxebild',
        share_facebook: 'Share by Facebook',
        'topp4-bilder': 'Topplacering bild',
        'suggest-ad': 'Söktips',
        sms: 'SMS',
        'kopieraorg.nummer': 'Copy corp.number',
        kopieraemail: 'Copy email',
        grunduppgift: 'Grunduppgift',
        direktbokning: 'Direktbokning',
        vardlank: 'Direktlänk Vård',
        butiklank: 'Direktlänk Butik',
        menylank: 'Direktlänk Meny',
        bestallank: 'Direktlänk Beställ',
        deluxeheader: 'Deluxeheader',
        'infosida-logo': 'Infosida logo',
        logo: 'Logo',
        suggest: 'Search suggestion',
        soktraff: 'Sökträff',
        kartuppgift: 'Kartuppgift',
        '-': '-',
        'result-customers-nearby': '(result-customers-nearby)',
        _clicklist: '(_clicklist)',
        '': '()',
        total: 'Total',
        other: 'Other',
    },

    PAGE_KEYS: {
        detail: 'Detail',
        list: 'Result list',
        map: 'Map',
        start: 'Start',
        other: 'Other',
        favourites: 'Favourites',
    },

    SOURCE_KEYS: {
        web: 'Web (desktop)',
        mobile: 'Web (mobile)',
        app: 'App',
        ios: 'iOS app',
        android: 'Android app',
        calltracking: 'Calltracking',
    },

    MONTHS: {
        0: 'January',
        1: 'February',
        2: 'Mars',
        3: 'April',
        4: 'May',
        5: 'June',
        6: 'July',
        7: 'August',
        8: 'September',
        9: 'October',
        10: 'November',
        11: 'December',
    },

    MONTHS_SHORT: {
        0: 'Jan',
        1: 'Feb',
        2: 'Mar',
        3: 'Apr',
        4: 'May',
        5: 'June',
        6: 'July',
        7: 'Aug',
        8: 'Sept',
        9: 'Oct',
        10: 'Nov',
        11: 'Dec',
    },

    DAYS_SHORT: {
        1: 'Mon',
        2: 'Tue',
        3: 'Wed',
        4: 'Thu',
        5: 'Fri',
        6: 'Sat',
        7: 'Sun',
    },
};

export default english;
